// aifab - Forced password change (first login / must_change_password)
import { useState } from 'react';
import { apiFetch } from '../hooks/apiFetch';
import { Spinner } from '../components/common';

export default function ChangePasswordPage({ email, onChanged }) {
  const [current, setCurrent] = useState('');
  const [next,    setNext]    = useState('');
  const [confirm, setConfirm] = useState('');
  const [err,     setErr]     = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (next.length < 12) { setErr('New password must be at least 12 characters.'); return; }
    if (next !== confirm) { setErr('New password and confirmation do not match.'); return; }
    if (next === current) { setErr('New password must differ from the current one.'); return; }
    setLoading(true);
    try {
      await apiFetch('/auth/change-password', {
        method: 'POST',
        body:   JSON.stringify({ current_password: current, new_password: next }),
      });
      // Server revokes all sessions on change - the user must sign in again.
      onChanged();
    } catch (e2) { setErr(e2.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-hd">
          <div className="login-wordmark">
            <span className="login-wordmark-aiiop">aiiop</span>
            <span className="login-wordmark-fabric"> Fabric</span>
          </div>
          <div className="login-subtitle">Set a new password to continue</div>
        </div>

        <div className="login-body">
          <div className="login-notice login-notice--warn">
            <span className="login-notice-icon">⚠</span>
            Your account requires a password change before you can continue
            {email ? ` (${email})` : ''}.
          </div>
          {err && (
            <div className="login-notice login-notice--err">
              <span className="login-notice-icon">✕</span>
              {err}
            </div>
          )}

          <form onSubmit={submit} className="login-form">
            <div className="form-grp">
              <label className="form-lbl">Current password</label>
              <input className="form-inp" type="password" value={current}
                     onChange={e => setCurrent(e.target.value)} autoFocus
                     placeholder="••••••••" />
            </div>
            <div className="form-grp">
              <label className="form-lbl">New password</label>
              <input className="form-inp" type="password" value={next}
                     onChange={e => setNext(e.target.value)}
                     placeholder="At least 12 characters" />
            </div>
            <div className="form-grp">
              <label className="form-lbl">Confirm new password</label>
              <input className="form-inp" type="password" value={confirm}
                     onChange={e => setConfirm(e.target.value)}
                     placeholder="Re-enter new password" />
            </div>
            <button className="btn btn-primary login-btn" disabled={loading} type="submit">
              {loading ? <Spinner size={14} /> : 'Change password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
